import apiClient from './ApiClient';
import { useAppContext } from './AppContext';
import { useEffect, useState } from 'react';
import { useEffectAsync } from '../helpers';

export const getAclTree = async () => {
	const tree = await apiClient.get('/acl/tree/me');

	return tree?.data || {};
};

export const buildAcl = async () => {
	console.log('downloading acl');
	const { resources, permissions } = await getAclTree();

	const tempAcl = {};

	for (const permission of permissions || []) {
		const resource = resources.find(r => r.id === permission.resourceId);

		if (typeof tempAcl[resource.key] === 'undefined') {
			tempAcl[resource.key] = {};
		}

		tempAcl[resource.key][permission.key] = {
			allowed: true,
		};
	}

	return tempAcl;
};

const verifyPermission = (acl: any, resource: string, permission?: string) => {
	if (!acl) {
		return false;
	}

	const r = acl[resource] || null;
	if (!r) {
		console.log('resorce ' + resource + ' not allowed');
		return false;
	}

	const p = r[permission || 'view'] || null;
	if (!p) {
		console.log(
			'permission ' +
				permission +
				' in resource ' +
				resource +
				' is not allowed',
		);
		return false;
	}

	console.log(
		'resorce ' + resource + (p.allowed ? ' allowed' : ' not allowed'),
	);
	return p.allowed;
};

export const isAllowed = (resource: string, permission?: string) => {
	const { aclData } = useAppContext();
	const [acl, setAcl] = useState(null);

	// @ts-ignore
	useEffectAsync(async () => {
		if (!aclData.loading) {
			aclData.loading = true;
			aclData.data = await buildAcl();
			aclData.fireListeners();
		}

		if (Object.keys(aclData.data).length) {
			setAcl(aclData.data);
		} else {
			aclData.listeners.push(() => {
				setAcl(aclData.data);
			});
		}
	});

	return verifyPermission(acl, resource, permission);
};

export const useStandaloneAcl = () => {
	return {
		isAllowed: (acl: any, resource: string, permission?: string) => {
			return verifyPermission(acl, resource, permission);
		},
		loadAcl: async () => {
			return await buildAcl();
		},
	};
};
